import { render, staticRenderFns } from "./OrderTypeModal.vue?vue&type=template&id=05483632&"
import script from "./OrderTypeModal.vue?vue&type=script&lang=js&"
export * from "./OrderTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderTypeModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports